import { useState } from 'react';
import { alpha } from '@classify/react-core-components/styles';

import Chip from './Chip';

export default function ColoredChip({
  color = 'black',
  selected = false,
  isOnContrasted = false,
  onClick,
  ariaLabel = 'Delete entry',
  ...otherProps
}) {
  const [isFocus, setFocus] = useState(false);

  let textColor = color;
  let backgroundColor = 'white';

  const handleFocus = () => setFocus(true);
  const handleBlur = () => setFocus(false);

  if (selected) {
    textColor = 'white';
    backgroundColor = color;
  } else if (isFocus && onClick) {
    textColor = color;
    backgroundColor = alpha(color, 0.2);
  }

  const borderColor = isOnContrasted ? 'transparent' : color;

  return (
    <Chip
      color={textColor}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      selected={selected}
      isOnContrasted={isOnContrasted}
      onClick={onClick}
      onMouseEnter={handleFocus}
      onMouseLeave={handleBlur}
      onFocus={handleFocus}
      onBlur={handleBlur}
      {...otherProps}
      ariaLabel={ariaLabel}
    />
  );
}
